<template>
  <BlocoFormularioCadastro voltar="/tabelasProcedimento" @salvar="salvar()">
    <template #toolbar>
      <button
        v-if="tabela._id"
        data-test-id="button-salvarcomonovo-1"
        type="button"
        class="btn btn-info"
        @click="salvarComoNovo()"
      >
        <span class="fa fa-file-o fa-lg" /> Salvar como novo
      </button>
    </template>
    <template #form>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4>Informações gerais</h4>
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                  <div class="form-group">
                    <label>Nome da tabela <sup>(1)</sup></label>
                    <input
                      id="tabela"
                      v-model="tabela.nome"
                      data-test-id="input-tabela"
                      type="text"
                      name="tabela"
                      class="form-control"
                      :readonly="tabela._id"
                    />
                  </div>
                </div>
                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                  <div class="form-group">
                    <label>Situação</label>
                    <select
                      id="ativo"
                      v-model="tabela.ativo"
                      data-test-id="select-ativo"
                      name="ativo"
                      class="form-control"
                    >
                      <option :value="true">Ativo</option>
                      <option :value="false">Cancelado</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              <div class="row">
                <div class="col-xs-6 col-sm-8 col-md-8 col-lg-8">
                  <h4>Procedimentos</h4>
                </div>
                <div class="col-xs-6 col-sm-4 col-md-4 col-lg-4">
                  <div class="btn-group pull-right" role="group">
                    <div class="btn-group btn-group-sm" role="group">
                      <button
                        id="botaoAdicionarProcedimento"
                        v-tooltip="'Adicionar um novo procedimento'"
                        data-test-id="button-botaoadicionarprocedimento"
                        type="button"
                        name="botaoAdicionarProcedimento"
                        class="btn btn-success"
                        @click="adicionarProcedimento()"
                      >
                        <span class="fa fa-plus" /> Procedimento
                      </button>
                    </div>
                    <div class="btn-group btn-group-sm" role="group">
                      <Longpress
                        id="botaoRemoverTodos"
                        v-tooltip="'Remover todos os procedimentos'"
                        :on-confirm="removerTodosProcedimentos"
                        name="botaoRemoverTodos"
                        class="btn btn-danger"
                        pressing-text="Removendo {$rcounter}"
                        action-text="Removido"
                        duration="3"
                      >
                        <span class="fa fa-trash" /> Todos
                      </Longpress>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel-body">
              <div v-if="!tabela.procedimentos.length" class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div class="well">
                    <p>Nenhum procedimento.</p>
                  </div>
                </div>
              </div>
              <div v-else class="row">
                <div style="height: 415px; overflow: auto">
                  <div
                    v-for="(procedimento, index) in tabela.procedimentos"
                    :key="procedimento.codigo"
                    class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
                  >
                    <div
                      :class="recuperaTipoPanel(procedimento, index)"
                      class="panel"
                    >
                      <div class="panel-heading">
                        <div class="row">
                          <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
                            <div
                              :class="
                                itemValidacao(index).codigo.$error
                                  ? 'has-error'
                                  : ''
                              "
                              class="input-group input-group-sm"
                            >
                              <span class="input-group-addon">Código</span>
                              <input
                                id="codigoProcedimento"
                                v-model.lazy="procedimento.codigo"
                                data-test-id="input-codigoprocedimento"
                                type="text"
                                name="codigoProcedimento"
                                class="form-control text-right"
                                placeholder="Código do procedimento"
                              />
                            </div>
                          </div>
                          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                            <Longpress
                              :value="procedimento"
                              :on-confirm="removeProcedimento"
                              class="btn btn-default btn-xs"
                              style="margin-top: 5px"
                              duration="3"
                              pressing-text="Removendo {$rcounter}"
                              action-text="Removido"
                            >
                              Remover
                            </Longpress>
                          </div>
                        </div>
                      </div>
                      <div class="panel-body">
                        <div class="row">
                          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div
                              :class="
                                itemValidacao(index).nome.$error
                                  ? 'has-error'
                                  : ''
                              "
                              class="form-group form-group-sm"
                            >
                              <textarea
                                id="nomeProcedimento"
                                v-model="procedimento.nome"
                                data-test-id="textarea-nomeprocedimento"
                                name="nomeProcedimento"
                                class="form-control"
                                style="resize: none"
                                placeholder="Nome do procedimento"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                            <div
                              :class="
                                itemValidacao(index).ch.$error
                                  ? 'has-error'
                                  : ''
                              "
                              class="input-group input-group-sm"
                            >
                              <span class="input-group-addon">CH</span>
                              <input
                                id="chProcedimento"
                                v-model="procedimento.ch"
                                v-mask="'money'"
                                data-test-id="input-chprocedimento"
                                type="text"
                                name="chProcedimento"
                                class="form-control text-right"
                                placeholder="Valor CH"
                              />
                            </div>
                          </div>
                          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                            <div
                              :class="
                                itemValidacao(index).valor_fixo.$error
                                  ? 'has-error'
                                  : ''
                              "
                              class="input-group input-group-sm"
                            >
                              <span class="input-group-addon">R$</span>
                              <input
                                id="valorFixoProcedimento"
                                v-model="procedimento.valor_fixo"
                                v-mask="'money'"
                                data-test-id="input-valorfixoprocedimento"
                                type="text"
                                name="valorFixoProcedimento"
                                class="form-control text-right"
                                placeholder="Valor fixo"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </BlocoFormularioCadastro>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { numeric, required, requiredIf } from '@vuelidate/validators'
import AwesomeMask from 'awesome-mask'
import numeral from 'numeral'
import Longpress from 'vue-longpress'

import BlocoFormularioCadastro from '@/componentes/formulario/BlocoFormularioCadastro'
import { useMenu } from '@/composables/useMenu'
import router from '@/router'
import MensagemServico from '@/servicos/MensagemServico'
import TabelaServico from '@/servicos/TabelaServico'

const tabelaServico = new TabelaServico()
const mensagemServico = new MensagemServico()

export default {
  directives: { mask: AwesomeMask },
  components: { Longpress, BlocoFormularioCadastro },
  setup() {
    useMenu(31)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      tabela: {
        nome: '',
        procedimentos: [],
        ativo: true,
      },
    }
  },
  validations: {
    tabela: {
      nome: { required },
      procedimentos: {
        required,
        $each: {
          codigo: { required, numeric },
          nome: { required },
          ch: {
            required: requiredIf((model) => {
              return !model.valor_fixo
            }),
          },
          valor_fixo: {
            required: requiredIf((model) => {
              return !model.ch
            }),
          },
        },
      },
    },
  },
  created() {
    this.recuperarTabela()
  },
  methods: {
    criarCampoCompativel(nome, erros = {}, touch = () => {}) {
      const errosCampo = Array.isArray(erros[nome]) ? erros[nome] : []
      return {
        $error: errosCampo.length > 0,
        $dirty: this.v$?.tabela?.procedimentos?.$dirty || false,
        required: !errosCampo.some((erro) => erro.$validator === 'required'),
        numeric: !errosCampo.some((erro) => erro.$validator === 'numeric'),
        $touch: touch,
      }
    },
    itemValidacao(index) {
      const colecao = this.v$?.tabela?.procedimentos
      const each = colecao?.$each
      const noop = () => {
        if (colecao && typeof colecao.$touch === 'function') {
          colecao.$touch()
        }
      }

      if (Array.isArray(each)) {
        return each[index] || {}
      }

      const erros = each?.$response?.$errors?.[index] || {}
      return {
        $error: Object.values(erros).some(
          (lista) => Array.isArray(lista) && lista.length > 0
        ),
        codigo: this.criarCampoCompativel('codigo', erros, noop),
        nome: this.criarCampoCompativel('nome', erros, noop),
        ch: this.criarCampoCompativel('ch', erros, noop),
        valor_fixo: this.criarCampoCompativel('valor_fixo', erros, noop),
      }
    },
    removeProcedimento(procedimento) {
      const index = this.tabela.procedimentos.indexOf(procedimento)
      this.tabela.procedimentos.splice(index, 1)
    },
    adicionarProcedimento() {
      this.tabela.procedimentos.unshift({
        codigo: '',
        nome: '',
        ch: '',
        valor_fixo: '',
      })
    },
    removerTodosProcedimentos() {
      this.tabela.procedimentos = []
    },
    recuperarTabela() {
      const id = this.$route.params.id

      if (id) {
        tabelaServico.recuperar(id).then((res) => {
          this.tabela = res.tabela
          this.tabela.procedimentos.forEach((proc) => {
            proc.ch = numeral(proc.ch).format('0,0.00')
            proc.valor_fixo = numeral(proc.valor_fixo).format('0,0.00')
          })
        })
      }
    },
    preSalvar() {
      this.tabela.procedimentos.forEach((proc) => {
        proc.ch = numeral(proc.ch).value()
        proc.valor_fixo = numeral(proc.valor_fixo).value()
      })
    },
    posSalvar(result) {
      if (result.erro) {
        mensagemServico.alerta(result.erro.content, result.erro.title)
        return
      }

      router.replace({ name: 'TabelasProcedimentoConsulta' })
    },
    salvarComoNovo() {
      this.tabela._id = ''
      this.salvar()
    },
    salvar() {
      this.v$.$touch()

      if (this.v$.tabela.$invalid) {
        mensagemServico.cadastroInvalido(this.v$)
      } else {
        this.preSalvar()

        if (this.tabela._id) {
          tabelaServico.atualizar(this.tabela._id, this.tabela).then((res) => {
            this.posSalvar(res)
          })
        } else {
          tabelaServico.criar(this.tabela).then((res) => {
            this.posSalvar(res)
          })
        }
      }
    },
    recuperaTipoPanel(procedimento, index) {
      let tipo = 'panel-default'

      if (this.itemValidacao(index).$error) {
        tipo = 'panel-danger'
      }

      return tipo
    },
  },
}
</script>
